<template>
  <section class="single-project">
    <header>
      <h2>Kurzübersicht</h2>
    </header>
      <main v-if="hasTemplates">
        <section class="left">
          <stack :configuration="configuration.configuration" />
          <p>Geschätzte Projektdauer: {{weeks}}</p>
        </section>
        <section class="right">
          <div class="configuration-details">
            <h3>Konfiguration</h3>
            <ul>
              <template v-for="(item, index) of selectedItems">
                <template v-if="index < 3">
                  <li :key="item.id">{{item.name}}<span v-if="item.amount > 0">: {{item.amount}}</span></li>
                </template>
                <template v-else>
                  <li v-if="showMoreDetails" :key="item.id">{{item.name}}<span v-if="item.amount > 0">: {{item.amount}}</span></li>
                </template>
              </template>
              <li v-if="selectedItems.length > 3 && !showMoreDetails">...</li>
            </ul>
            <template v-if="selectedItems.length > 3">
              <button v-if="showMoreDetails" @click="toggleDetails()" class="backend-button blue-button less-button">weniger Details</button>
              <button v-else @click="toggleDetails()" class="backend-button blue-button more-button">mehr Details</button>
            </template>
          </div>
        </section>
      </main>
      <main v-else>
        <p>Sie müssen der Konfiguration mindestens ein Template hinzufügen, um sie abschließen zu können.<br><br>
        <router-link to="/templates" class="backend-button blue-button">Zur Template-Auswahl</router-link></p>
      </main>
  </section>
</template>
<script>
import Stack from '@/components/Stack.vue'
export default {
  name: 'Summary',
  components: {
    Stack
  },
  props: {
    configuration: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      showMoreDetails: false
    }
  },
  computed: {
    weeks: function () {
      if (((this.total / 30) / 6) / 5 < 2) {
        return 1 + 1 + ' Wochen'
      } else {
        return 1 + Math.floor(((this.total / 30) / 6) / 5) + ' Wochen'
      }
    },
    hasTemplates: function () {
      if (this.hasBlog || this.hasShop || this.hasPageTemplates) {
        return true
      } else {
        return false
      }
    },
    hasPageTemplates: function () {
      return this.configuration.configuration.find(item => item.id === 'pages').status
    },
    hasShop: function () {
      return this.configuration.configuration.find(item => item.id === 'onlineshop').status
    },
    hasBlog: function () {
      return this.configuration.configuration.find(item => item.id === 'blogfunktion').status
    },
    selectedItems: function () {
      return this.configuration.configuration.filter(item => item.status === true)
    }
  },
  methods: {
    toggleDetails: function () {
      this.showMoreDetails = !this.showMoreDetails
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/css/variables.scss";
.single-project {
  @include tile();
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  .backend-button {
    @include backend-button();
    &.blue-button {
      color: #fff;
      text-decoration: none;
      &:hover {
        background: #728DF8;
        text-decoration: none;
      }
    }
    &.less-button {
      margin-top: 8px;
      display: flex;
      align-items: center;
      &:before {
        margin-top: 2px;
        margin-right: 6px;
        width: 21px;
        height: 21px;
        min-width: 21px;
        display: block;
        content: '';
        background-image: url('../assets/img/icons/roundLessWhite.svg');
      }
    }
    &.more-button {
      margin-top: 8px;
      display: flex;
      align-items: center;
      &:before {
        margin-top: 2px;
        margin-right: 6px;
        width: 21px;
        height: 21px;
        min-width: 21px;
        display: block;
        content: '';
        background-image: url('../assets/img/icons/roundMoreWhite.svg');
      }
    }
  }
  header {
    background: #fafafa;
    padding: 15px 20px;
    width: 100%;
    h2 {
      font-size: 18px;
      font-family: $primaryFont;
      font-weight: $primaryFontBold;
      color: $primaryFontColor;
      line-height: 1.1;
      margin: 5px 0;
      hyphens: auto;
    }
  }
  main {
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    background-color: $primaryColor;
    color: #fff;
    p {
      margin-bottom: 4px;
    }
    strong {
      font-weight: $secondaryFontBold;
    }
    input {
      font-size: 16px;
      font-family: $secondaryFont;
      font-weight: $secondaryFontNormal;
      color: #fff;
      padding: 0;
      margin: 0;
      outline: none;
      border: none;
      background-color: none;
      background-color: transparent;
      line-height: 1.5;
      width: auto;
    }
    .left {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      p {
        margin-top: 40px;
      }
    }
    .right {
      width: 100%;
      .configuration-details {
        width: 100%;
        padding: 40px 0 0 0;
        ul {
          margin: 10px 0 0 0;
          padding: 0 0 0 20px;
          li {
            list-style: none;
            position: relative;
            font-size: 16px;
            margin-bottom: 4px;
          }
          li:before {
            content:'';
            display:inline-block;
            background-position:center center;
            background-repeat:no-repeat;
            margin-right:8px;
            position: absolute;
            top: 6px;
            left: -20px;
            width: 14px;
            height: 14px;
            background-image: url('../assets/img/icons/listCheckWhite.svg');
          }
        }
      }
    }
    section {
      &.title-section {
        display: flex;
        align-items: center;
        .title-edit {
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;
        }
      }
    }
  }
  footer {
    display: flex;
    justify-content: end;
    justify-content: flex-end;
    padding: 15px 20px;
  }
}
@media(min-width:767px) {
  .single-project {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    header {
      flex-wrap: nowrap;
      .status {
        text-align: center;
        flex-direction: column;
        width: 80px;
        margin: 0 12px 0 0;
        &:before {
          margin-bottom: 6px;
          margin-right: 0;
        }
      }
      h2 {
      }
    }
    main {
      flex-direction: row;
      .left {
        flex-direction: column;
        width: 50%;
        padding: 0 20px 0 0;
      }
      .right {
        width: 50%;
        margin: 0;
        padding: 0 0 0 20px;
        border-left: 1px solid #728df8;
        .configuration-details {
          width: 100%;
          padding: 0 0 0 0;
        }
      }
    }
  }
}
@media(min-width:1180px) {
  .single-project {
    header {
      padding: 20px 20px;
    }
  }
}
.deatils-enter,
.deatils-leave-to {
  opacity: 0;
  transform: rotateY(50deg);
}
.deatils-enter-to,
.deatils-leave {
  opacity: 1;
  transform: rotateY(0deg);
}
.deatils-enter-active,
.deatils-leave-active {
  transition: opacity, transform 200ms ease-out;
}
</style>
